export default "__VITE_ASSET__2c6258dd__"